import type { Language } from '@/shared/lib/i18n'
import { getFontTheme } from '@/styles/global-fonts'
import '@/styles/index.css'
import '@/styles/vendor.css'

export function StylesProvider({ lang }: { lang: Language }) {
    const fontTheme = getFontTheme(lang)

    const globalStyles = `
        :root {
            --font-source-sans-pro: ${fontTheme.sourceSansPro};
            --font-noto-sans: ${fontTheme.notoSans};
            --font-montserrat: ${fontTheme.montserrat};
        }
    `

    return <style>{globalStyles}</style>
}
